import React, { FunctionComponent } from 'react'
import styled from 'styled-components'

// import { Dropdown, DropdownButton } from 'react-bootstrap'
import Row from '../components/Row';
import DropdownMenu from '../components/dropdown/DropdownMenu';
import { styles } from '../styles/themes/style';
import DropdownItem from '../components/dropdown/DropdownItem';
import Text from '../components/Text';
import SvgFragment from './SvgFragment';

export interface ICustomColorModalProps {
    color?: string,
    disabled?: boolean,
    customDesign?: boolean,
    onColorChangedHandler: (e: any) => void
    openCustomColorModalHandler: (e: any) => void,
    label?: string,
    showFocusStyle?: boolean
}

const ColorSelectDropdownFragment: FunctionComponent<ICustomColorModalProps> = ({ color, disabled, customDesign = false, onColorChangedHandler, openCustomColorModalHandler, label, showFocusStyle = false }) => {
    const colors = [
        { colorName: 'Default', colorCode: styles.colors.primary600, id: 'default-color' },
        { colorName: 'Blue', colorCode: styles.colors.blue600 },
        { colorName: 'Turquoise', colorCode: styles.colors.turquise600 },
        { colorName: 'Green', colorCode: styles.colors.green600 },
        { colorName: 'Yellow', colorCode: styles.colors.yellow600 },
        { colorName: 'Orange', colorCode: styles.colors.orange600},
        { colorName: 'Red', colorCode: styles.colors.red600 },
        { colorName: 'Gray', colorCode: styles.colors.black600 },
    ]

    return (
        <DropdownMenu 
            $hideToggle={disabled}
            disabled={disabled}
            title={
                <TitleWrapper>
                    <ColorDropdown style={!customDesign ? { backgroundColor: color } : { backgroundColor: 'transparent', border: `2px solid ${styles.colors.primary600}` }} />
                    {label && <BoldLabel>{label}</BoldLabel>}
                </TitleWrapper>
            }
            backgroundColor={showFocusStyle ? '#EEF3FF' : 'transparent'}
            color={styles.colors.primary600}
            fontSize={'14px'}
            $height={'24px'}
            $padding={'0px 6px 0px 0px'}
        >
            {colors.map((color: any) => (
                <DropdownItem key={color?.colorCode} onClickHandler={() => onColorChangedHandler(color.colorCode)}>
                    <Row>
                        <ColorCircle style={{ backgroundColor: color.colorCode }} />
                        <Text>{color.colorName}</Text>
                    </Row>
                </DropdownItem>
            ))}
            <DropdownItem onClickHandler={openCustomColorModalHandler}>
                <Row alignItems gap='15px'>
                    <SvgFragment type='plus' />
                    <Text>Add Custom Color</Text>
                </Row>
            </DropdownItem>
        </DropdownMenu>
    )
}

const ColorDropdown = styled.span`
    height: 16px;
    width: 16px;
    display: inline-block;
    border-radius: 50%;
    background-color: red;
`
const ColorCircle = styled.span`
    height: 16px;
    width: 16px;
    display: inline-block;
    border-radius: 50%;
    margin-right: 10px;
    line-height: 32px;
    vertical-align: middle;
`
const TitleWrapper = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-right: 6px;
`

const BoldLabel = styled.span`
    color: ${styles.colors.primary600};
    font-family: 'Nunito Sans', NunitoSans, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
`

export default ColorSelectDropdownFragment